import React, { useContext, useEffect, useRef, useState } from 'react'
import RightSvgIcon from '../../../Svg/RightSvgIcon';
import Chevdown from '../../../Svg/ChevronDownSvg';
import Chevup from '../../../Svg/ChevronUpSvg';
import AlertContext from '../../../context/AlertContext';
import constants from '../../../constants';
import { useParams } from 'react-router-dom';


export default function Rdropdown({type, data, handleApplyBlockFilters, placeholder, refreshPage}) {
  const { selectedStatus, setSelectedStatus, selectedChapters, selectedDropdown, setSelectedDropdown, selectedBranch, appliedModules } = useContext(AlertContext)
  
  const [openCDropdown, setOpenCDropdown] = useState(false);
  const wrapperRef = useRef(null);
  
  const { lpid } = useParams();
  let selectedDropdowns = selectedDropdown && selectedDropdown[type];
  
      useEffect(()=>{
        // setSelectedDropdown((prev) => ({
        //     ...prev,
        //     [type]: null,
        // }));
        // setSelectedDropdown(null);
        setOpenCDropdown(false)
      },[lpid])

    // close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpenCDropdown(false); // Close the dropdown if click is outside
            }
            };

            if (openCDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
            } else {
            document.removeEventListener('mousedown', handleClickOutside);
            }

            return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            };
    }, [openCDropdown]);

    useEffect(()=>{
        if(selectedStatus && !refreshPage && type === "Status" && selectedChapters.length === 1){      
            data.forEach(data=>{
                if(data.value === selectedStatus){
                    // setSelectedDropdown(data);
                    setSelectedDropdown((prev) => ({
                        ...prev,
                        [type]: data,
                    }));
                }
            })
        }

        if(selectedChapters.length > 1){
            data.forEach(data=>{
                if(data.value === selectedStatus){
                    handleApplyBlockFilters(data, type);
                    // setSelectedDropdown(null);
                    setSelectedDropdown((prev) => ({
                        ...prev,
                        [type]: null,
                    }));
                }
            })
        }

    /* Only for Types */
        // if(libtype && refreshPage && type === "Types"){
        //     data.forEach(data=>{
        //         if (data.value === "assignment") setSelectedDropdown(data);
        //         if (data.value === "ccq") return setSelectedDropdown(data);
        //         if (data.value === "descriptive") setSelectedDropdown(data);
        //         if (data.value === "mcq") setSelectedDropdown(data);
        //         if (data.value === "sql") setSelectedDropdown(data);
        //         if (data.value === "active") setSelectedDropdown(data);
        //         if (data.value === "inactive") setSelectedDropdown(data);
        //         if (data.value === "practice") setSelectedDropdown(data);
        //     })
        // }

    },[selectedStatus, refreshPage, selectedChapters]);

/* For change college */
    useEffect(()=>{
        if(selectedBranch === null){            
            setSelectedDropdown((prev) => ({
                ...prev,
                branch: null,
            }));
            
        selectedDropdowns = selectedDropdown[type]
        }
    }, [selectedBranch])
    
/* Change status,college,branch */
    const handleSelect = (item) => {
        if(selectedDropdown){
            setSelectedDropdown((prev) => ({
                ...prev,
                [type]: prev[type]?.value === item.value ? null : item,
            }));

            handleApplyBlockFilters(item, type);
        } else  {
            console.log("handleSelect else");
        }
    };

    const appliedCount = Object.values(appliedModules || {}).flat().length;
    const isDisabled = type !== "college" && type !== "branch" && appliedCount !== 1;

  return (
    <div className="module_div" ref={wrapperRef}>
        <div className="rm_module_div">
            <button
                className={`rm_selected_module ${openCDropdown ? "mdactive" : ""}`}
                onClick={() => setOpenCDropdown(!openCDropdown)}
                // disabled={(type !== "college" && type !== "branch") && (selectedChapters.length>1 || selectedChapters.length==0)}
                disabled={isDisabled}
            >
                <span className='rm_selected_module_name'>{selectedDropdowns ? selectedDropdowns.label : placeholder}</span><span>{openCDropdown ? <Chevup from={"rmdropdown"}/> :<Chevdown from={"rmdropdown"}/>}</span>
            </button>
            {openCDropdown && (
                <div className="rm_module">
                {data.map((mod, index) => (
                    <div
                    key={index}
                    className="rm_module_label"
                    onClick={() => {
                        // setSelectedDropdown(selectedDropdown && selectedDropdown.value === mod.value ? null : mod);
                        // handleApplyBlockFilters(mod);
                        handleSelect(mod);
                        setOpenCDropdown(false);
                    }}
                    >
                    {mod.label}
                    {(selectedDropdown && selectedDropdown[type]) && selectedDropdown[type].value === mod.value ? <div>
                        <RightSvgIcon rmmodule={true}/>
                    </div> : <></>}
                    </div>
                ))}
                </div>
            )}
        </div>
    </div>
  )
}
